import { createIcon } from './createIcon';

/** Rightward chevron — "this leads somewhere", on a row or a submenu. */
export const ChevronRightIcon = createIcon({
  name: 'ChevronRightIcon',
  viewBox: '0 0 16 16',
  size: 14,
  children: (
    <path
      d="M6 4l4 4-4 4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

export default ChevronRightIcon;
